import React, { useMemo } from 'react';
import CustomIcon, { IconType } from '../../shared/custom-icon/custom-icon';
import { Link, useLocation, useParams } from 'react-router-dom';

import './app-navigation.scss';

const AppNavigation: React.FC = () => {

    const location = useLocation();
    const { customerId, serviceId } = useParams();

    const items = [
        {
            label: 'Overview',
            key: 'dashboard-menu-item',
            href: `dashboard`,
            icon: IconType.DASHBOARD
        },
        {
            label: 'Policy',
            key: 'policy-menu-item',
            href: `protection`,
            icon: IconType.PROTECTION
        },
        {
            label: 'Insights',
            key: 'insights-menu-item',
            href: `insights`,
            icon: IconType.INSIGHTS
        }];

    const activeItem = useMemo(() =>
        location.pathname.split('/')?.[3],
        [location.pathname]);


    return (
        <div className="app-navigation">
            {items.map(item => (
                <Link key={item.key} className={`navigation-link ${activeItem === item.href ? 'active' : ''}`} to={`/${customerId}/${serviceId}/${item.href}`}>
                    <CustomIcon className="navigation-link-icon" type={item.icon} />
                    <span className={`navigation-link-label ${item.label.toLowerCase()}-label`}>{item.label}</span>
                </Link>
            ))}
        </div>
    );
};

export default AppNavigation;